import React from "react";
import { TextQuestion } from "../../components/TextQuestion";
import {
  DatePicker,
  FormGroup,
  SubmitButton,
} from "../../../../@coherent/react-hook-form";
import { TextareaQuestion } from "../../components/TextareaQuestion";
import { FormProvider, useForm } from "react-hook-form";
import moment from "moment";
import { get } from "lodash";

export function ParentalConsentForm({ required = true, data, onSubmit }) {
  const methods = useForm({
    defaultValues: data,
  });
  const { handleSubmit, formState } = methods;
  const { errors } = formState;
  const { application__organisation__organisation_name } = data;

  return (
    <FormProvider {...methods}>
      <p className="mb-4">
        We encourage and appreciate the efforts of volunteers under the age of
        18. Before a child begins volunteering, we require consent from the
        parent(s) or legal guardian(s). To give consent, please complete and
        submit the form below.
      </p>

      <TextQuestion
        name="child_name"
        label="Child's name"
        required={required}
      />

      <FormGroup
        name="child_date_of_birth"
        label="Child's date of birth"
        required={required}
        help={
          <>
            {get(errors, "child_date_of_birth.type") === "ofAge" && (
              <>{errors.child_date_of_birth.message}</>
            )}
          </>
        }
      >
        <DatePicker
          name="child_date_of_birth"
          className="form-control"
          defaultValue={null}
          rules={{
            required: required,
            validate: {
              ofAge: (v) => {
                if (!required) return true;
                if (!v) return false;
                const d = moment.duration(moment().startOf("day") - moment(v));
                return (
                  (d.years() >= 11 && d.years() < 18) ||
                  "Young Helpers must be between 11 and 17 years old."
                );
              },
            },
          }}
        />
      </FormGroup>

      <TextQuestion
        name="name"
        label="Parent/guardian's name"
        required={required}
      />

      <TextareaQuestion
        name="address"
        label="Parent/guardian's address"
        required={required}
      />

      <TextQuestion
        name="phone_number"
        label="Parent/guardian phone number"
        required={required}
      />
      <hr />
      <p>Alternate contact in case of emergency:</p>

      <TextQuestion
        name="alternative_contact_name"
        label="Name"
        required={required}
      />

      <TextQuestion
        name="alternative_relationship"
        label="Relationship to child"
        required={required}
      />

      <TextQuestion
        name="alternative_phone_number"
        label="Phone number"
        required={required}
      />

      <p className="mt-6">
        By submitting this form, I, the parent or legal guardian of the child
        named above, consent to the child's participation in volunteer
        activities organised by the Make Lunch team at{" "}
        {application__organisation__organisation_name}.
      </p>
      <div className="tw-flex tw-justify-end">
        <SubmitButton onClick={handleSubmit(onSubmit)}>Confirm</SubmitButton>
      </div>
    </FormProvider>
  );
}
